import ApiError from './error';

export const CustomError = function (object) {
  this.status = object.status;
  this.title = object.title;
  this.message = object.message;
  this.data = object.data;
};

/**
 * @param {*} options - TODO
 */
export const request = async ({ url, method = 'GET', body = undefined, credentials = 'include' }) => {
  const headers = { Accept: 'application/json' };

  if (method === 'GET' && body !== undefined) {
    console.error('IE doesnt support GET Xhr requests with body');
  }

  const requestData = {
    headers,
    method,
    body: body && JSON.stringify(body),
    credentials
  };

  return fetch(url, requestData)
    .catch((error) => {
      throw new ApiError(error);
    })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (typeof data === 'string') {
        return data;
      }

      const json = data;

      switch (json.status) {
        case 200:
          return json;
        case 201:
          return json;
        default:
          throw new CustomError(json);
      }
    });
};
